import Avatar from 'flarum/common/components/Avatar';
export default function avatar(user, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  return m(Avatar, {
    ...attrs,
    user
  });
}
flarum.reg.add('flatrate-forum-navigation', 'forum/utils/avatar', avatar);